function CodeExamplesService () {
    this.examples = []
    this.examples.push(`
Algoritmo sinnombre
    
FinAlgoritmo
    `.trim())
}

CodeExamplesService.prototype = {
    getInitialCode () {
        return this.examples[0]
    }
}

export const CodeExamples = new CodeExamplesService()



// WEBPACK FOOTER //
// ./src/Helpers/CodeExamples.js